import classNames from "classnames/dedupe";
import { useLocale } from "../../../../hooks/useLocale";
import { filterCovers } from "../../QuoteCard/filterCovers";
import { Header } from "../../QuoteCard/Header";
import { HeaderUK } from "../../QuoteCard/Header/HeaderUK";
import { NoQuoteCard } from "../../QuoteCard/NoQuoteCard/NoQuoteCard";
import { Pricing } from "../../QuoteCard/Pricing";
import { QuoteActions } from "../../QuoteCard/QuoteActions";
import type { Quote } from "../../types";
import { Coverage } from "./Coverage";
import { Pricing as PricingUK } from "./PricingUK/Pricing";

export type QuoteCardProps = {
  hideNoQuoteCard?: boolean;
  quote: Quote;
  variant?: string;
};

export const QuoteCard = ({
  quote,
  variant,
  hideNoQuoteCard,
}: QuoteCardProps) => {
  const { status } = quote;
  const insurer = quote.covers[0]?.coverInsurer;
  const insurerParametrized = insurer?.toLowerCase().replaceAll(" ", "-");
  const chopinTestId = `buy-${insurerParametrized}-block`;
  const { isUK } = useLocale();

  const filteredCovers = filterCovers(quote);

  const classes = classNames("mobius-quote-card");

  if (status === "referred") {
    if (hideNoQuoteCard === true) {
      return <></>;
    }

    return <NoQuoteCard insurer={insurer} insurerLogo={quote.insurerLogo} />;
  }

  return (
    <div
      role="listitem"
      className={classes}
      id={chopinTestId}
      data-testid="quote-cards-list-item"
    >
      {isUK ? (
        <HeaderUK
          logo={quote.insurerLogo}
          underWriterText={quote.underwriter}
        />
      ) : (
        <Header
          logo={quote.insurerLogo}
          insurerFinancialStrengthRatings={quote.ratings}
        />
      )}
      {isUK ? (
        <PricingUK quote={quote} displayBadges showInstallmentsInformation />
      ) : (
        <Pricing quote={quote} displayBadges showInstallmentsInformation />
      )}
      <Coverage
        covers={filteredCovers}
        additionalCoverage={quote.additionalCoverage}
        displayVariant="qcp"
        withModal
        variant={variant}
        upsells={quote.upsells}
      />
      <QuoteActions quote={quote} variant={variant} />
    </div>
  );
};
